import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import Pagination from "../../../../../common/components/organisme/Pagination/Pagination";
import { OrderByType } from "../../../../../utils/genericAPI/useGenericAPI";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";

import useHardware, { useSingleHardware } from "../../../hooks/useHardware";
import { Hardware, HardwaresType, translateHardwaresType } from "../../../types/hardware.types";
import HardwareListView from "./HardwareListView/HardwareListView";

import useSingleStation from "../../../../stations/hooks/useSingleStation";
import ButtonSmallIcon from "../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useSingleChargePoint } from "../../../../stations/hooks/useChargePoint";
import { useSingleConnector } from "../../../../stations/hooks/useConnectors";
import { limitString } from "../../../../../utils/string.utils";
import { ButtonWithComfirmationModal,  } from "../../../../../common/components/organisme/ModalWindow/ModalWindow";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";


export default function HardwareListPresenter({
  pageSize = 8,
  orderBy,
}: {
  pageSize?: number;
  orderBy?: OrderByType<Hardware>;
}) {
  const {
    getAllQuery: { isLoading, isError, data, error, setPage },
  } = useHardware({ pageSize: pageSize, orderBy: orderBy });

  return (
    <>
      {isLoading && <LoaderSreen heigth={"200px"} />}
      {!isLoading && isError && <ErrorScreenApp axiosError={error} />}
      {!isLoading && !isError && (
        <>
          {" "}
          <HardwareListView
            content={
              data?.data?.map((item) => {
                return {
                  id: item.hardware_id,
                  devuid: item.hardware_device_id+"" || "N/A",
                  hardwareType:  translateHardwaresType(item.hardware_type || "N/A") as any,
                  secretKey: item.hardware_secret_key,
                  secretKeyAvoir: item.hardware_secret_key_credit,
                  AssociatedElement: () => (
                    <AssociatedHardware
                      idStation={item.hardware_station}
                      idConnector={item.hardware_connector}
                      idChargePoint={item.hardware_charge_point}
                      type={item.hardware_type}
                    />
                  ),
                  ActionBtnRender: () => <ActionBtn id={item.hardware_id} />,
                };
              }) || []
            }
            nbFound={data?.pagination.total_count}
          />
          <Pagination
            centered={true}
            setCurrentPage={setPage}
            currentPage={data?.pagination.current_page}
            lastPage={data?.pagination.total_pages}
          />
        </>
      )}
    </>
  );
}

const AssociatedHardware = ({
  idStation,
  idConnector,
  idChargePoint,
  type,
}: {
  idStation?: string;
  idConnector?: string;
  idChargePoint?: string;
  type: HardwaresType;
}) => {
  const { singleStationQuery } = useSingleStation(idStation);
  const { singleChargePointQuery } = useSingleChargePoint({
    stationId: idStation,
    chargePointId: idChargePoint,
  });
  const { getSingleConnectorQuery } = useSingleConnector({
    chargePoint: idChargePoint,
    connectorId: idConnector,
  });
  const navigateApp = useNavigationApp();

  if (type === "STATION") {
    const onClick = () => {
      navigateApp.goToSingleStation(idStation);
    };
    if (singleStationQuery.isLoading) return <>...</>;
    if (singleStationQuery.isError) return <></>;
    if (singleStationQuery.data)
      return (
        <ButtonSmallIcon
          width={"80px"}
          iconType={"electricStation"}
          label={limitString(singleStationQuery.data?.station_name || "NA", 7)}
          onClick={onClick}
        />
      );
  }

  if (type === "CHARGEPOINT") {
    const onClick = () => {
      navigateApp.goToSingleChargePoint(idStation, idChargePoint);
    };
    if (singleChargePointQuery.isLoading) return <>...</>;
    if (singleChargePointQuery.isError) return <>-</>;
    if (singleChargePointQuery.data)
      return (
        <ButtonSmallIcon
          width={"80px"}
          iconType={"thunder"}
          label={limitString(
            singleChargePointQuery.data?.charge_point_name || "NA",
            7
          )}
          onClick={onClick}
        />
      );
    return <></>;
  }

  if (type === "CONNECTOR") {
    const onClick = () => {
      navigateApp.goToSingleConnector(idStation, idChargePoint, idConnector);
    };
    if (getSingleConnectorQuery.isLoading) return <>...</>;
    if (getSingleConnectorQuery.isError) return <></>;
    if (getSingleConnectorQuery.data)
      return (
        <ButtonSmallIcon
          width={"80px"}
          iconType={"electric-car-plug"}
          label={limitString(
            getSingleConnectorQuery.data?.b_connector_slug || "NA",
            7
          )}
          onClick={onClick}
        />
      );
  }
  return <></>;
};

const ActionBtn = ({ id }: { id: string }) => {
  const {
    deleteQuery: deleteQ,
    singleQuery: { isError, data },
  } = useSingleHardware(id);

  const {userRole} = useAuth();

  if (!(userRole && userRole >= userRoles.SUPER_ADMIN)) return <></>;

  if (isError) return <></>;

  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <ButtonWithComfirmationModal
        titleModal="Suppression"
        desc={
          "Voulez-vous vraiment supprimer cet hardware devUID " +
          data?.hardware_device_id +
          "?"
        }
        height={"10px"}
        fontSize={"0.8rem"}
        borderRaduis={"10px"}
        variant={"outlined"}
        isLoading={deleteQ.isLoading}
        onClick={() => {
          deleteQ.mutate({});
        }}
        label="Supprimer"
        borderColor="#7C030370"
        fontColorHex="#7C030370"
        bgColorHex="transparent"
      />
    </div>
  );
};
